export default [{
  path: '/online-works',
  name: 'onlineWork',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/onlineWork/index')
}]
